import { useEffect, useContext, useState } from "react";
import { post } from "../../../../adapters/xhr/api";
import stylesModal from "./Modal.module.css";
import Moment from "moment";

import stylesRequestData from "../../UnifiedTaxDeclarationRequestData/index.module.css";
import SearchSelectElement from "../../../../shared/form/SearchSelectElement";
import InputElement from "../../../../shared/form/InputElement";
import UnifiedTaxDeclarationContext from "../../../../contexts/UnifiedTaxDeclarationProvider";
import FieldRenderer from "../common/FieldRendrer";
import Modal from "react-modal";
import { DatePickerFormatedWithLimit } from "../../../../shared/form/DatePickerFormated";
import { useLocation, useNavigate } from "react-router-dom";

// import MultiSelectElement from "../../../shared/form/MultiSelectElement";

const FixedInstallationForm = ({
  generateOptions,
  installationTypes,
  unitAttachments,
  error_new_user,
  setValidFields,
  handleChangeDeclerationUnit,
  ownershipDeedFileInputRef,
  leaseContractFileInputRef,
  setUploadFileError,
  setError,
  fileInputKeys,
  DownloadFile,
  handlePreviewFile,
  setTempFiles,
}) => {
  Modal.setAppElement("body");
  const location = useLocation();
  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const {
    user,
    declarationRequest,
    updateDeclarationUnit,
    isUnitInSameBuilding,
    getUnitInitialValue,
    showPropertyTypeModal,
    setShowPropertyTypeModal,
    propertyTypes,
    setDeclarationRequest,
  } = unifiedTaxDeclarationContext;

  // State for date pickers
  const [contractStartDate, setContractStartDate] = useState(null);
  const [contractEndDate, setContractEndDate] = useState(null);
  const [fileErrors, setFileErrors] = useState({});

  const creationDate = declarationRequest?.created_at
    ? Moment(declarationRequest?.created_at).toDate()
    : new Date();

  const endDateLimit = contractEndDate
    ? Moment(contractEndDate).subtract(1, "day").toDate()
    : null;

  const contractStartMaxDate =
    endDateLimit && endDateLimit < creationDate ? endDateLimit : creationDate;

  const isTaxpayerOwner = [
    { id: 1, name: "نعم" }, // Yes
    { id: 2, name: "لا" }, // No
  ];

  const navigate = useNavigate();

  useEffect(() => {
    if (
      declarationRequest?.unit?.id &&
      (declarationRequest?.viewMode || declarationRequest?.editMode)
    ) {
      setContractStartDate(new Date(declarationRequest?.unit?.contract_start));
      setContractEndDate(new Date(declarationRequest?.unit?.contract_end));
    }
  }, []);

  // Auto-fill installation owner when taxpayer is the owner
  useEffect(() => {
    if (
      parseInt(declarationRequest?.unit?.is_taxpayer_owner_of_installation) ===
      1
    ) {
      let ownerName;
      //  ownerName = user?.profile?.full_name || "";

      if ([1, 3, 4].includes(parseInt(declarationRequest?.applicant_role_id))) {
        ownerName = user?.profile?.full_name || "";
      }

      if ([5, 6, 7].includes(parseInt(declarationRequest?.applicant_role_id))) {
        if (parseInt(declarationRequest?.taxpayer?.type_id) === 1) {
          ownerName =
            declarationRequest?.taxpayer?.first_name +
            " " +
            declarationRequest?.taxpayer?.last_name;
        }
        if (parseInt(declarationRequest?.taxpayer?.type_id) === 2) {
          ownerName = declarationRequest?.taxpayer?.name;
        }
      }

      if (parseInt(declarationRequest?.applicant_role_id) === 2) {
        ownerName = declarationRequest?.taxpayer?.name;
      }

      updateDeclarationUnit("installation_owner_name", ownerName);
    }
  }, [
    declarationRequest?.unit?.is_taxpayer_owner_of_installation,
    user?.profile?.full_name,
  ]);

  useEffect(() => {
    if (parseInt(declarationRequest?.unit?.installation_type_id, 10) !== 3) {
      updateDeclarationUnit("installation_type_other", null);
    }
  }, [declarationRequest?.unit?.installation_type_id]);

  const handleDateChange = (parentCompenent, compenent, key, value) => {
    let keyInUnit;
    if (key === "contractStartDate") {
      setContractStartDate(value);
      keyInUnit = "contract_start";
      setContractEndDate(null);
      setDeclarationRequest((prev) => ({
        ...prev,
        unit: {
          ...prev.unit,
          contract_end: null,
        },
      }));
    } else {
      setContractEndDate(value);
      keyInUnit = "contract_end";
    }
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        [keyInUnit]: Moment(value).format("yyyy-MM-DD"),
      },
    }));
  };

  const formFields = ({
    declarationRequest,
    error_new_user,
    handleChangeDeclerationUnit,
    generateOptions,
    stylesRequestData,
  }) => [
    {
      type: "select",
      colClass: "col-md-4",
      name: "installation_type_id",
      labelText: "نوع التركيب",
      labelHtmlFor: "installation_type_id",
      options: generateOptions(installationTypes),
      defaultText: "أختار نوع التركيب..",
      value: declarationRequest?.unit?.installation_type_id,
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.installation_type_id,
      stylesRequestData,
      required: true,
      valueType: "string",
    },
  ];

  const fields = formFields({
    declarationRequest,
    error_new_user,
    handleChangeDeclerationUnit,
    generateOptions,
    stylesRequestData,
  });

  const handleChangeUnitFile = async (pc, c, key, value, i, bi, fi, ref) => {
    try {
      const data = new FormData();
      data.append(`label`, key);
      data.append(`file`, value);

      if (value) {
        const response = await post(
          "api/declaration-system/declarations/upload-attachments",
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          },
          data,
        );

        // setDeclarationRequest((prev) => ({
        //   ...prev,
        //   [key]: response?.data?.data,
        // }));
        updateDeclarationUnit(key, response?.data?.data);
        setError(key, "");
        setUploadFileError(null);
        setFileErrors((prev) => ({ ...prev, [key]: "" }));
        if (location?.pathname?.includes("add") && !declarationRequest?.id) {
          setTempFiles((prev) => [...prev, response?.data?.data?.path]);
        }
      }
    } catch (error) {
      if (error.status === 422) {
        setValidFields((prev) => ({
          ...prev,
          key: false,
        }));
        // setDeclarationRequest((prev) => ({
        //   ...prev,
        //   [key]: null,
        // }));
        updateDeclarationUnit(key, null);
        window.scrollTo(0, 0);
        // setError(key, "يجب رفع الصورة");
        setUploadFileError(error?.response?.data?.errors?.file);
        setFileErrors((prev) => ({
          ...prev,
          [key]: error?.response?.data?.errors?.file?.[0] || "خطأ في الملف",
        }));
        if (ref?.current) {
          ref.current.value = null;
        }
      }
    }
  };

  const attachedEssentialDocuments = [
    {
      key: "ownership_deed",
      label: "مرفق سند الملكية، الإنتفاع، أو الإستغلال",
      file: declarationRequest?.unit?.ownership_deed,
    },
  ].filter((document) => document.file !== null && document.file !== undefined);

  // useEffect(() => {
  //   if (isUnitInSameBuilding) {
  //     setDeclarationRequest((prev) => ({
  //       ...prev,
  //       unit: {
  //         ...prev?.unit,
  //         installation_owner_name: "",
  //         contract_start: null,
  //         contract_end: null,
  //       },
  //     }));
  //     updateDeclarationUnit("installation_owner_name", "");
  //     setContractStartDate(null);
  //     setContractEndDate(null);
  //   }
  // }, [isUnitInSameBuilding, setDeclarationRequest]);

  const handleSelectPropertyTypeIdModal = () => {
    const selectedPropertyTypeId =
      declarationRequest?.unit?.property_type_id_modal;

    if (!selectedPropertyTypeId) {
      setError("property_type_id_modal", "يجب اختيار نوع العقار");
      return;
    }

    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...getUnitInitialValue(),
        buildingProfile: prev?.unit?.buildingProfile || null,
        known_build_num: prev?.unit?.known_build_num || null,
        address_additional_info: prev?.unit?.address_additional_info || null,
        is_map_address_matching: prev?.unit?.is_map_address_matching || null,
        mismatch_reason_id: prev?.unit?.mismatch_reason_id || null,
        correct_city_other: prev?.unit?.correct_city_other || null,
        correct_district_other: prev?.unit?.correct_district_other || null,
        correct_mogawra_other: prev?.unit?.correct_mogawra_other || null,
        correct_village_other: prev?.unit?.correct_village_other || null,
        correct_street_other: prev?.unit?.correct_street_other || null,
        correct_settlement_other: prev?.unit?.correct_settlement_other || null,
        correct_astrick_colour: prev?.unit?.correct_astrick_colour || null,
        is_taxpayer_owner_of_installation:
          prev?.unit?.is_taxpayer_owner_of_installation || null,
        installation_owner_name: prev?.unit?.installation_owner_name || null,
        contract_start: prev?.unit?.contract_start || null,
        contract_end: prev?.unit?.contract_end || null,
        fixed_installation_number:
          prev?.unit?.fixed_installation_number || null,

        filter_search_type_id: prev?.unit?.filter_search_type_id ?? 3,
        renin:
          prev?.unit?.manual_renin ||
          prev?.unit?.renin ||
          prev?.unit?.buildingProfile?.renin ||
          null,
        manual_city: prev?.unit?.manual_city || null,
        manual_district: prev?.unit?.manual_district || null,
        manual_governorate_id: prev?.unit?.manual_governorate_id || null,
        manual_governorate_name: prev?.unit?.manual_governorate_name || null,
        manual_known_build_num: prev?.unit?.manual_known_build_num || null,
        manual_mogawra: prev?.unit?.manual_mogawra || null,
        manual_policestation_id: prev?.unit?.manual_policestation_id || null,
        manual_policestation_name:
          prev?.unit?.manual_policestation_name || null,
        manual_renin: prev?.unit?.manual_renin || null,
        manual_settlement: prev?.unit?.manual_settlement || null,
        manual_street: prev?.unit?.manual_street || null,
        manual_village: prev?.unit?.manual_village || null,
        property_type_id: selectedPropertyTypeId,
        property_type_id_modal: selectedPropertyTypeId,
        // usage_type:
        //   selectedPropertyTypeInt === 1
        //     ? "سكني"
        //     : [2, 3, 4].includes(selectedPropertyTypeInt)
        //       ? "غير سكني"
        //       : null,
      },
    }));

    if (isUnitInSameBuilding) {
      setDeclarationRequest((prev) => ({
        ...prev,
        unit: {
          ...prev?.unit,
          installation_owner_name: "",
          contract_start: null,
          contract_end: null,
        },
      }));
      updateDeclarationUnit("installation_owner_name", "");
      updateDeclarationUnit("is_taxpayer_owner_of_installation", null);
      setContractStartDate(null);
      setContractEndDate(null);
    }

    setError("property_type_id_modal", "");
    setShowPropertyTypeModal(false);
  };
  return (
    <>
      <Modal
        isOpen={showPropertyTypeModal}
        // onRequestClose={() => setShowPropertyTypeModal(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        {" "}
        <div className="col-lg-8 w-100 w-md-75">
          <SearchSelectElement
            mb4="mb-4"
            labelHtmlFor="property_type_id_modal"
            labelClassName={` required form-label ${stylesRequestData["form-label"]} text-center`}
            labelText="نوع العقار"
            selectClassName={`${stylesRequestData["form-select"]} form-select `}
            selectID="property_type_id_modal"
            inputId="property_type_id_modal_input"
            name="property_type_id_modal"
            options={generateOptions(propertyTypes)}
            default="أختار نوع العقار .."
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            pText={error_new_user.property_type_id_modal}
            value={declarationRequest?.unit?.property_type_id_modal}
            onChange={handleChangeDeclerationUnit}
            // isClearable={true}
            disabled={
              declarationRequest?.viewMode || declarationRequest?.isUnitViewMode
            }
          />
        </div>
        <div className="d-flex gap-2 justify-content-start flex-wrap">
          <button
            className="btn btn-primary px-4 py-2"
            onClick={handleSelectPropertyTypeIdModal}
          >
            إضافة عقار جديد
          </button>

          <button
            className="btn btn-primary px-4 py-2"
            onClick={() => {
              setShowPropertyTypeModal(false);
              setDeclarationRequest({
                ...declarationRequest,
                isShowOnlyUnit: false,
                isUnitEditMode: false,
                isUnitViewMode: false,
              });
              if (declarationRequest?.id) {
                navigate(`/tax-declaration/update/${declarationRequest?.id}`);
              }
            }}
          >
            إلغاء
          </button>
        </div>
      </Modal>

      {fields.map((field) => (
        <FieldRenderer key={field.name} field={field} />
      ))}

      {/* Conditional field for Other Installation Type */}
      {parseInt(declarationRequest?.unit?.installation_type_id, 10) === 3 && (
        <div className="col-md-4">
          <InputElement
            mb4="mb-4"
            labelHtmlFor="installation_type_other"
            labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
            labelText="نوع التركيب الآخر"
            inputType="text"
            maxLength={100}
            inputClassName={`${stylesRequestData["form-control"]} form-control`}
            inputID="installation_type_other_input"
            name="installation_type_other"
            placeholder="ادخل نوع التركيب الآخر.."
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            value={declarationRequest?.unit?.installation_type_other || ""}
            allowedPattern={
              /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
            }
            onChange={handleChangeDeclerationUnit}
            pText={error_new_user.installation_type_other}
            disabled={
              declarationRequest?.viewMode || declarationRequest?.isUnitViewMode
            }
          />
        </div>
      )}

      {/* Is Taxpayer Owner */}
      <div className="col-md-4">
        <SearchSelectElement
          mb4="mb-4"
          labelHtmlFor="is_taxpayer_owner_of_installation"
          labelClassName={`required form-label ${stylesRequestData["form-label"]}`}
          labelText="هل المكلف بأداء الضريبة هو مالك التركيب؟"
          selectClassName={`${stylesRequestData["form-select"]} form-select`}
          selectID="is_taxpayer_owner_of_installation"
          inputId="is_taxpayer_owner_of_installation_input"
          name="is_taxpayer_owner_of_installation"
          options={generateOptions(isTaxpayerOwner)}
          default="أختار.."
          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
          pText={error_new_user.is_taxpayer_owner_of_installation}
          value={parseInt(
            declarationRequest?.unit?.is_taxpayer_owner_of_installation,
          )}
          onChange={handleChangeDeclerationUnit}
          isClearable={true}
          disabled={
            declarationRequest?.viewMode || declarationRequest?.isUnitViewMode
          }
        />
      </div>

      {/* Installation Owner */}
      <div className="col-md-4">
        <InputElement
          mb4="mb-4"
          labelHtmlFor="installation_owner_name"
          labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
          labelText="مالك التركيب"
          inputType="text"
          maxLength={100}
          inputClassName={`${stylesRequestData["form-control"]} form-control`}
          inputID="installation_owner_name_input"
          name="installation_owner_name"
          placeholder="ادخل اسم مالك التركيب.."
          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
          value={declarationRequest?.unit?.installation_owner_name || ""}
          allowedPattern={/^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/}
          onChange={handleChangeDeclerationUnit}
          pText={error_new_user.installation_owner_name}
          disabled={
            parseInt(
              declarationRequest?.unit?.is_taxpayer_owner_of_installation,
            ) === 1 ||
            declarationRequest?.viewMode ||
            declarationRequest?.isUnitViewMode
          }
        />
      </div>

      {/* Contract Start Date */}
      {declarationRequest?.viewMode || declarationRequest?.isUnitViewMode ? (
        <div className="col-lg-4 col-sm-6">
          <InputElement
            value={declarationRequest?.unit?.contract_start}
            disabled={true}
            name="contract_start"
            mb4="mb-4"
            labelHtmlFor="contract_start"
            labelClassName={` ${stylesRequestData["form-label"]} form-label`}
            labelText={"تاريخ بداية التعاقد"}
            inputType="text"
            inputClassName={`${stylesRequestData["form-control"]} form-control`}
            inputID="contract_start_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
          />
        </div>
      ) : (
        <div className="col-lg-4 col-sm-6">
          <DatePickerFormatedWithLimit
            name="contractStartDate"
            name_datepicker="contractStartDate"
            mb4="mb-4"
            labelHtmlFor="contractStartDate"
            labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
            labelText="تاريخ بداية التعاقد"
            inputType="datePicker"
            maxDate={contractStartMaxDate}
            inputClassName="form-control"
            inputID="contract_start_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            pText={error_new_user.contract_start}
            value={contractStartDate}
            placeholderText="تاريخ بداية التعاقد"
            onChange={handleDateChange}
            isDisabled={
              declarationRequest?.viewMode || declarationRequest?.isUnitViewMode
            }
            onChangeRaw={(e) => e.preventDefault()}
          />
        </div>
      )}

      {/* Contract End Date */}
      {declarationRequest?.viewMode ||
      declarationRequest?.isUnitViewMode ||
      !contractStartDate ? (
        <div className="col-lg-4 col-sm-6">
          <InputElement
            value={declarationRequest?.unit?.contract_end}
            disabled={true}
            name="contract_end"
            mb4="mb-4"
            labelHtmlFor="contract_end"
            labelClassName={` ${stylesRequestData["form-label"]} form-label`}
            labelText={"تاريخ نهاية التعاقد"}
            inputType="text"
            inputClassName={`${stylesRequestData["form-control"]} form-control`}
            inputID="contract_end_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
          />
        </div>
      ) : (
        <div className="col-lg-4 col-sm-6">
          <DatePickerFormatedWithLimit
            name="contractEndDate"
            name_datepicker="contractEndDate"
            mb4="mb-4"
            labelHtmlFor="contractEndDate"
            labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
            labelText="تاريخ نهاية التعاقد"
            inputType="datePicker"
            maxDate={Moment().add(50, "years")}
            minDate={Moment(contractStartDate)
              ?.add(1, "day")
              .format("YYYY-MM-DD")}
            inputClassName="form-control"
            inputID="contract_end_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            pText={error_new_user.contract_end}
            value={contractEndDate}
            placeholderText="تاريخ نهاية التعاقد"
            onChange={handleDateChange}
            isDisabled={
              declarationRequest?.viewMode || declarationRequest?.isUnitViewMode
            }
          />
        </div>
      )}

      {/* Annual Rental Value */}
      <div className="col-md-4">
        <InputElement
          mb4="mb-4"
          labelHtmlFor="annual_rent_value"
          labelClassName={`${stylesRequestData["form-label"]} form-label`}
          labelText="القيمة الإيجارية السنوية"
          inputType="text"
          maxLength={22}
          inputClassName={`${stylesRequestData["form-control"]} form-control`}
          inputID="annual_rent_value_input"
          name="annual_rent_value"
          placeholder="ادخل القيمة الإيجارية السنوية.."
          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
          value={declarationRequest?.unit?.annual_rent_value || ""}
          allowedPattern={/^(?!0+(?:\.0{0,2})?$)\d{1,19}(?:\.\d{0,2})?$/}
          onChange={handleChangeDeclerationUnit}
          pText={error_new_user.annual_rent_value}
          disabled={
            declarationRequest?.viewMode || declarationRequest?.isUnitViewMode
          }
          tooltipText=" القيمة الإيجارية المدخلة عن السنة بالكامل"
        />
      </div>

      {(declarationRequest?.isUnitViewMode ||
        declarationRequest?.isUnitEditMode) &&
        declarationRequest?.unit?.fixed_installation_number !== null &&
        !isUnitInSameBuilding && (
          <div className="col-md-4">
            <InputElement
              mb4="mb-4"
              labelHtmlFor="fixed_installation_number"
              labelClassName={`${stylesRequestData["form-label"]} form-label`}
              labelText="رقم التركيب الثابت"
              inputType="text"
              maxLength={22}
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="fixed_installation_number_input"
              name="fixed_installation_number"
              placeholder="ادخل رقم التركيب الثابت.."
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              value={declarationRequest?.unit?.fixed_installation_number || ""}
              allowedPattern={/^(?!0+(?:\.0{0,2})?$)\d{1,19}(?:\.\d{0,2})?$/}
              // onChange={handleChangeDeclerationUnit}
              pText={error_new_user.fixed_installation_number}
              disabled={true}
            />
          </div>
        )}

      {/* Ownership Document */}

      {!declarationRequest?.viewMode && !declarationRequest?.isUnitViewMode && (
        <>
          <div className="col-md-4">
            <InputElement
              fileInputRef={ownershipDeedFileInputRef}
              mb4="mb-4"
              key={`ownership-${fileInputKeys.ownership_deed}`}
              inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
              labelHtmlFor="ownership_deed"
              labelClassName={` ${stylesRequestData["form-label"]} form-label  `}
              labelText="سند الملكية، الإنتفاع، أو الإستغلال"
              inputType="file"
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="ownership_deed_input"
              name="ownership_deed"
              fileName={
                declarationRequest?.unit?.ownership_deed?.original_file_name ||
                "إرفاق ملف"
              }
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              icon="fa-solid fa-cloud-arrow-up"
              accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
              pText={fileErrors["ownership_deed"]}
              hideErrorMessage
              onChange={handleChangeUnitFile}
              customServerInput={
                declarationRequest?.unit?.ownership_deed !== null ? true : false
              }
              disabled={
                declarationRequest?.viewMode ||
                declarationRequest?.isUnitViewMode
              }
              deleteFunction={() => {
                handleChangeDeclerationUnit("", "", "ownership_deed", null);
                if (ownershipDeedFileInputRef?.current) {
                  ownershipDeedFileInputRef.current.value = null;
                }
              }}
            />
          </div>
        </>
      )}

      {(declarationRequest?.viewMode || declarationRequest?.isUnitViewMode) &&
        attachedEssentialDocuments.length > 0 && (
          <div className={`${stylesRequestData.box} box pdf-box`}>
            <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
              قائمة المستندات الأساسية
            </h4>
            <div className="row">
              {attachedEssentialDocuments.map((document) => (
                <div className="col-md-4" key={document.key}>
                  <label
                    htmlFor={document.key}
                    className={`${stylesRequestData["form-label"]} form-label`}
                  >
                    {document.label}
                  </label>
                  <div className=" col-2-4 d-flex border border-2  rounded-3 shadow-sm fs-6 justify-content-between bg-light py-2 px-2 align-items-center mb-3">
                    <p
                      className="mb-0 file-name fs-6"
                      title={document.file?.original_file_name}
                    >
                      {document.file?.original_file_name}
                    </p>
                    <div className="d-flex align-items-center py-2">
                      <span
                        type="button"
                        onClick={() =>
                          handlePreviewFile(document.file?.full_url)
                        }
                        className={`text-danger border-0`}
                      >
                        <i
                          className="fa-slab-press fa-regular fa-eye fa-lg px-2"
                          style={{ color: "#32A8ED" }}
                        ></i>
                      </span>
                      <span
                        type="button"
                        onClick={() => DownloadFile(document.file?.full_url)}
                        className={`text-danger border-0`}
                      >
                        <i
                          className="fa-solid fa-cloud-arrow-down fa-lg px-2"
                          style={{ color: "#32A8ED" }}
                        ></i>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
    </>
  );
};

export default FixedInstallationForm;
